import React, { FC } from 'react';
import { useTranslations, TranslationKey } from '@lang';
import { PageTitle } from '../../Typography';
import { Section } from '../Section';

type TitleProps = {
  titleId: TranslationKey;
};

export const Title: FC<TitleProps> = ({ titleId }) => {
  const { t } = useTranslations();
  return (
    <Section>
      <PageTitle>{t(titleId)}</PageTitle>
    </Section>
  );
};
